<template>
  <div>
    <div class="videoDetails">
      <div class="video_detail">
        <div class="video_detail_left">
          <div class="video_detail_left_title">{{title}}</div>
          <div class="video_detail_left_author">
            <div class="video_left_author">{{teach_name}}</div>
            <div class="video_left_time">2020-03-26</div>
          </div>
          <div class="videos_details">
            <video
              id="vide"
              class="video-js v2 ani resize"
              :src="videoDetail.video_url"
              type="video/mp4"
              :poster="videoDetail.v_cover"
              webkit-playsinline="true"
              x5-video-player-type="h5"
              controls="controls"
            ></video>
          </div>

          <div class="video_shang" v-if="up" @click="getvideo(up_id)">上一篇：{{up}}</div>
          <div class="video_next" v-if="down" @click="getvideo(down_id)">下一篇：{{down}}</div>
          <div class="video_xing">
              <img :src="starSC" @click="addSC" v-if="is_collect">
              <img :src="starH" @click="delSC" v-else>
              <div class="video_xing_SC" @click="addSC" v-if="is_collect">取消收藏</div>
              <div class="video_xing_SC" @click="delSC" v-else >点我收藏</div>
          </div>
        </div>
        <div class="video_detail_right">
            <div class="video_detail_right_title">热门收藏</div>
            <div class="video_detail_right_content" @click="getvideo(item.v_id)" v-for="(item, index) in manager_list.slice(0,7)" :key="index">
                <div class="video_detail_right_img">
                  <img :src="item.cover" alt="">
                </div>
                <div class="video_detail_right_des">{{item.title}}</div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { videoDetail ,videoHot, addVideoCollect, delVideoCollect} from "../../api/api";

export default {
  name: "videoDetail",
  inject: ['reload'],
  data() {
    return {
      video_id: "",
      videoDetail: "",
      isPlay: false,
      starSC: "./static/img/starSC.png",
      starH: "./static/img/starH.png",
      teach_name:"",
      title:"",
      up:"",
      down:"",
      up_id:"",
      down_id:"",
      manager_list:[],
      is_collect:""
    };
  },
  mounted() {
    this.$store.commit("settab", 3);
    this.video_id = this.$route.params.id;
    //console.log(localStorage.getItem("ticket"))
    videoDetail({
      ticket: localStorage.getItem("ticket"),
      v_id: this.video_id
    }).then(res => {
      this.videoDetail = res.data.data;
      this.teach_name = res.data.data.teach_name;
      this.title = res.data.data.title;
      this.up = res.data.data.pages.up.title
      this.down = res.data.data.pages.down.title
      this.up_id = res.data.data.pages.up.id
      this.down_id = res.data.data.pages.down.id
      this.is_collect = this.videoDetail.is_collect
      //console.log(res.data.data);
    });
    videoHot({
        ticket : localStorage.getItem("ticket"),
      }).then(res => {
        //console.log(res.data.data)
        this.manager_list = res.data.data;
    });
  },
  methods: {
    getvideo(id){
      this.reload();
      this.$router.push({path:'/videoDetail/'+ id})
    },
    delSC(){
      addVideoCollect({
        ticket: localStorage.getItem("ticket"),
        video_id: this.video_id
      }).then(res => {
        if(res.retcode == 2000){
          this.is_collect = 1
          this.$message({
            message: '收藏成功',
            type: 'success'
          });
        }
      })
    },

    addSC(){
      delVideoCollect({
        ticket: localStorage.getItem("ticket"),
        video_id: this.video_id
      }).then(res => {
        if(res.retcode == 2000){
          this.is_collect = 0
          this.$message({
            message: '取消成功',
            type: 'success'
          });
        }
      })
    }
  }
};
</script>

<style>
.videoDetails {
  margin: 30px 0 80px 0;
  background: #eeeeee;
}
.video_detail {
  width: 1410px;
  display: flex;
  margin: 0 auto;
}
.video_detail_left {
  margin: 12px 0;
  width: 1151px;
  height: 1115px;
  background: #ffffff;
}
.video_detail_right {
  margin: 12px 0;
  width: 400px;
  height: 1115px;
  background: #ffffff;
  margin-left: 10px;
}
.video_detail_left_title {
  margin: 0 auto;
  padding-top: 63px;
  text-align: center;
  /* width: 500px; */
  height: 39px;
  font-size: 38px;
}
.video_detail_left_author {
  display: flex;
  width: 230px;
  margin: 0 auto;
  margin-top: 65px;
  font-size: 18px;
}
.video_left_author {
  margin-right: 29px;
}
.videos_details {
  width: 1000px;
  height: 600px;
  margin: 0 auto;
  margin-top: 80px;
  margin-bottom: 66px;
}
.videos_details video {
  height: 100%;
  width: 100%;
}
.video_shang {
  /* margin-top: 66px; */
  margin-left: 10px;
  font-size: 18px;
  color: #000000;
  cursor: pointer;
}
.video_next {
  margin-top: 13px;
  margin-left: 10px;
  font-size: 18px;
  color: #000000;
  cursor: pointer;
}
.video_xing{
  display: flex;
  flex-direction: column;
  float: right;
  margin-top: -70px;
  justify-content: center;
  align-items: center;
  margin-right: 60px;
}
.video_xing img{
  width: 38px;
  height: 38px;
}
.video_xing_SC{
  margin-top: 5px;
  font-size: 14px;
  cursor: pointer;
}
.video_detail_right_title{
  font-size: 24px;
  margin-left: 14px;
  margin-top: 26px;
  color: #000000;
}
.video_detail_right_content{
    display: flex;
    width: 342px;
    margin: 0 auto;
    border-bottom: 1px solid #D3D3D3;
    margin-top: 27px;
    cursor: pointer;
}
.video_detail_right_img{
    width: 129px;
    height: 86px;
    background: #D3D3D3;
    margin-bottom: 27px;
}
.video_detail_right_img img{
  width: 100%;
  height: 100%;
}
.video_detail_right_des{
    width: 200px;
    margin-left: 14px;
    font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/manager/videoDetail.vue